// extracted by mini-css-extract-plugin
module.exports = {"inputLabel":"inputAutocomplete_inputLabel__2-aov","inputText":"inputAutocomplete_inputText__23C1A"};